/**
 * Group Form — keep AOGEN Connect group-activity block in place and
 * prefill hidden booking fields from the workshop wizard.
 */
(function () {
  'use strict';

  var CONTEXT_KEYS = [
    'venue_id',
    'venue_name',
    'city',
    'state',
    'country',
    'workshop_type',
    'available_event_dates',
    'product_id',
    'product_name',
    'product_handle'
  ];

  function root() {
    return document.querySelector('[data-amc-group-form]');
  }

  function groupBlock(section) {
    section = section || root();
    if (!section) return null;
    return section.querySelector('.aogen-forms-block');
  }

  function markBlock(block) {
    if (!block) return;
    block.setAttribute('data-amc-group-form-block', '1');
    block.setAttribute('data-wbw-aogen-skip', '1');
  }

  function setHiddenInput(form, name, value) {
    if (!form || !name) return;
    var val = value == null ? '' : String(value);
    var input =
      form.querySelector('input[type="hidden"][name="' + name + '"]') ||
      form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = val;
  }

  function applyContext(detail) {
    detail = detail || {};
    var section = root();
    var block = groupBlock(section);
    if (!block) return;
    markBlock(block);

    CONTEXT_KEYS.forEach(function (key) {
      if (detail[key] == null || detail[key] === '') return;
      block.setAttribute('data-' + key.replace(/_/g, '-'), String(detail[key]));
    });

    var form =
      block.querySelector('form') ||
      block.querySelector('.aogen-forms-form') ||
      block;
    CONTEXT_KEYS.forEach(function (key) {
      if (detail[key] == null) return;
      setHiddenInput(form, key, detail[key]);
    });

    /* Ensure form_key stays group-activity even if Connect remounts. */
    if (detail.form_key && detail.form_key !== 'waitlist') {
      setHiddenInput(form, 'form_key', detail.form_key);
    } else {
      setHiddenInput(form, 'form_key', 'group-activity');
    }
  }

  function contextFromVenueEvent(e) {
    var d = (e && e.detail) || {};
    var venue = d.venue || d.selectedVenue || d;
    if (!venue || typeof venue !== 'object') return null;
    var booking = document.querySelector('[data-product-id], .wb-booking, .wbw-root');
    if (typeof window.wbBuildAogenBookingContext === 'function') {
      var built = window.wbBuildAogenBookingContext(venue, booking, {
        intent: 'inline',
        country: d.country || ''
      });
      built.form_key = 'group-activity';
      return built;
    }
    var venueRef =
      venue.venue_ref_id != null
        ? String(venue.venue_ref_id)
        : venue.venue_id != null
          ? String(venue.venue_id)
          : '';
    return {
      form_key: 'group-activity',
      venue_id: venueRef,
      venue_name: String(venue.venue_name || venue.name || ''),
      city: String(venue.city || venue.city_name || ''),
      state: String(venue.state || venue.state_code || ''),
      country: String(d.country || 'USA'),
      workshop_type: String(d.workshop_type || '')
    };
  }

  function onBookingContext(e) {
    var detail = (e && e.detail) || {};
    /* Clone so waitlist form_key is not forced onto group form. */
    var copy = {};
    CONTEXT_KEYS.forEach(function (key) {
      if (detail[key] != null) copy[key] = detail[key];
    });
    copy.form_key = 'group-activity';
    applyContext(copy);
  }

  function onVenueSelected(e) {
    var ctx = contextFromVenueEvent(e);
    if (ctx) applyContext(ctx);
  }

  function boot() {
    var block = groupBlock();
    markBlock(block);
  }

  document.addEventListener('aogen:booking-context', onBookingContext);
  document.addEventListener('wbw:venue-selected', onVenueSelected);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.querySelector && e.target.querySelector('[data-amc-group-form]')) {
      boot();
    }
  });
})();
